import { default as NewCompleteComponent } from "features/wallets/components/cards/NewComplete";
import type { FC } from "react";

const NewComplete: FC = () => {
  return <NewCompleteComponent />;
};

export default NewComplete;
